export function formatLosAngelesTimestamp() {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).formatToParts(new Date());
  const values = Object.fromEntries(
    parts.map((part) => [part.type, part.value])
  );
  return `${values.year}-${values.month}-${values.day}_${values.hour}:${values.minute}:${values.second}`;
}

export function storageFilename(fileName, timestamp = formatLosAngelesTimestamp()) {
  const basename = fileName.replace(/\.[^/.]+$/, '') || 'image';
  const extension = fileName.split('.').pop()?.toLowerCase() || 'jpg';
  return `${basename}_${timestamp}.${extension}`;
}

export async function uploadImageToStorage(storage, file) {
  const fileRef = storage.ref().child(storageFilename(file.name));
  await fileRef.put(file, {
    contentType: file.type || 'image/jpeg',
    customMetadata: {
      originalName: file.name,
      originalType: file.type || '',
    },
  });
  return fileRef.getDownloadURL();
}
